import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { AnexosService } from "../services/anexos.service";

@Injectable({
  providedIn: 'root'
})
export class AnexosResolver {

  constructor(private service: AnexosService) { }

  getAll(id:number = null): Observable<any> {
    return this.service.getAll(id);
  }
}

@Injectable({
  providedIn: 'root'
})
export class AnexosResolverId {

  constructor(private service: AnexosService) { }

  getAttachById(attach_id:number): Observable<any> {
    return this.service.getAttachById(attach_id);
  }
}